import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3226b3a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shooting-create-pin-table b-page-tie-panoramas-right col-lg-6" }
const _hoisted_2 = {
  id: "panoramas-grid",
  class: "grid-view"
}
const _hoisted_3 = { class: "js-discussions-list-count-wrapper" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Всего панорам: ")
const _hoisted_5 = { class: "js-discussions-list-count" }
const _hoisted_6 = { class: "shooting-create-pin-table__table b-panorama-table js-panorama-table table table-striped table-bordered" }
const _hoisted_7 = { class: "shooting-create-pin-table__thead" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "#", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Привязка", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Миниатюра", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Имя файла", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Дата съемки", -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShootingPinTableLine = _resolveComponent("ShootingPinTableLine")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.panoramas.length), 1)
      ]),
      _createElementVNode("table", _hoisted_6, [
        _createElementVNode("thead", _hoisted_7, [
          _createElementVNode("tr", null, [
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _hoisted_11,
            _hoisted_12,
            (_ctx.plans.length > 1)
              ? (_openBlock(), _createElementBlock("th", _hoisted_13, "План"))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.panoramas, (panorama, i) => {
            return (_openBlock(), _createBlock(_component_ShootingPinTableLine, {
              key: panorama.id,
              active: i === _ctx.activePanoramaIndex,
              index: i + 1,
              panorama: panorama,
              showPlan: _ctx.plans.length > 1,
              plan: _ctx.getPlan(i),
              onClick: ($event: any) => (_ctx.$emit('lineClicked', i))
            }, null, 8, ["active", "index", "panorama", "showPlan", "plan", "onClick"]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("p", _hoisted_14, [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn btn-default", { disabled: !_ctx.unpinButtonIsEnabled }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('unpinPointFromActivePanorama')))
      }, " Отвязать панораму ", 2),
      _createElementVNode("button", {
        class: "btn btn-success",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('submit')), ["prevent"]))
      }, " Сохранить и продолжить ")
    ])
  ]))
}